module.exports = __webpack_public_path__ + "img/benefits-office.21903fe4.jpg";